import type { ThemeConfig } from 'antd';
import { COLOR } from 'utilities/constants/COLOR';

const AppTheme: ThemeConfig = {
    token: {
        colorPrimary: COLOR.PRIMARY,
        borderRadius: 4,
        fontFamily: 'Noto Sans JP',
        fontFamilyCode: 'Noto Sans JP',
        fontSize: 12,
        colorText: '#000000',
        colorTextBase: '#000000',
        colorLink: COLOR.LINK,
        colorBgBase: '#ffffff',
        colorIcon: '#999999',
        // colorBgContainer: '#ff0000',
        //     colorBgLayout: '#00ff00',
        //     colorFillContent: '#0000ff',
    },
};

export default AppTheme;
